module.exports = __webpack_public_path__ + "static/logo4-0c379d88535b510abe82a1ec8b5016b3.jpg";